import { UsernamePasswordLogin } from "@/shared/coralreef";
import { viewWidth } from "csx";
import { Content } from "gls/lib";
import { useState } from "react";

export interface LoginPageProps {
  signIn(email: string, password: string): Promise<{ isSignedIn: boolean }>;
  onSuccess(): void;
}

export function LoginPage({ signIn, onSuccess }: LoginPageProps) {
  const [error, setError] = useState<string | null>(null);

  const onLoginPasswordSubmitHandler = (username: string, password: string) => {
    setError(null);
    signIn(username, password)
      .then((r) => {
        if (r.isSignedIn) onSuccess();
      })
      .catch((e) => {
        setError(e instanceof Error ? e.message : "Sign-in failed");
      });
  };

  return (
    <Content
      width={viewWidth(100)}
      height="75vh"
      verticalAlign="center"
      horizontalAlign="center"
    >
      <div className="flex flex-col items-center gap-3">
        <UsernamePasswordLogin onSubmit={onLoginPasswordSubmitHandler} />
        {error && (
          <div
            role="alert"
            data-testid="error-message"
            className="text-red-500 text-sm w-[300px]"
          >
            {error}
          </div>
        )}
      </div>
    </Content>
  );
}
